import AjaxCart from '../helpers/AjaxCart'
import Money from '../helpers/Money'

class CartPage {
    constructor (theme, elem) {
        this.name = this.constructor.name
        this._theme = theme
        this._elem = elem
        this._box = elem.querySelector('[data-summary-box]')
        this._main = elem.querySelector('[data-main]')
        this._data = JSON.parse(elem.dataset.cartPage)
        this._moneyFormat = this._data.moneyFormat
    }

    onInit () {
        if (window.innerWidth > 768 && this._box) {
            document.addEventListener('scroll', () => {
                this.onScroll()
            })
            this.onScroll()
        }
        const items = this._elem.querySelectorAll('[data-item]')
        if (items.length > 0) {
            for (let item of items) {
                let remove = item.querySelector('[data-remove]')
                if (remove) {
                    remove.addEventListener('click', (e) => {
                        e.preventDefault()
                        this.removeItem(item)
                    })
                }
                let plus = item.querySelector('[data-plus]')
                let minus = item.querySelector('[data-minus]')

                if (plus && minus) {
                    plus.addEventListener('click', () => { this.quantityPlus(item) })
                    minus.addEventListener('click', () => { this.quantityMinus(item) })
                }
            }
        }
    }
    onScroll () {
        let top = this._main.offsetTop
        let offset = 150
        let boxHeight = this._box.scrollHeight
        let mainHeight = this._main.offsetHeight
        if (mainHeight > boxHeight && window.innerWidth > 768) {
            if (scrollY + offset > top) {
                this._box.style.top = `${(scrollY + offset) - top}px`
            } else {
                this._box.style.top = '0px'
            }
            if (scrollY + offset + boxHeight > top + mainHeight && boxHeight < mainHeight) {
                this._box.style.top = `${(mainHeight) - boxHeight}px`
            }
        }
    }
    async removeItem (element) {
        let lineID = this.getItemKey(element)
        if (lineID) {
            element.classList.add('removing')
            await AjaxCart.removeItem(lineID)
            element.classList.remove('removing')
            element.classList.add('removed')
        }
        this.updateCart()
    }

    async quantityPlus (element) {
        let lineID = this.getItemKey(element)
        let quantity = parseInt(element.dataset.quantity)
        if (lineID) {
            let payload = {
                id: lineID,
                quantity: quantity + 1
            }
            await AjaxCart.changeItem(payload)
        }
        this.updateCart()
    }
    async quantityMinus (element) {
        let lineID = this.getItemKey(element)
        let quantity = parseInt(element.dataset.quantity)
        if (lineID && quantity > 1) {
            let payload = {
                id: lineID,
                quantity: quantity - 1
            }
            await AjaxCart.changeItem(payload)
            this.updateCart()
        }
        if (lineID && quantity <= 1) {
            this.removeItem(element)
        }
    }

    async updateCart () {
        const response = await AjaxCart.getCart()
        const cart = response.data
        // console.log(cart)
        if (cart.item_count <= 0) {
            window.location.href = '/cart'
        } else {
            const subtotal = this._box.querySelector('[data-subtotal]')
            const saved = this._box.querySelector('[data-saved]')
            const total = this._box.querySelector('[data-total]')
            if (subtotal && saved && total) {
                subtotal.innerHTML = Money.formatMoney(cart.original_total_price, this._moneyFormat)
                saved.innerHTML = Money.formatMoney(cart.total_discount, this._moneyFormat)
                total.innerHTML = Money.formatMoney(cart.total_price, this._moneyFormat)
            }
            const items = this._elem.querySelectorAll('[data-item]:not(.removed)')
            if (items.length > 0) {
                if (items.length < cart.items.length) {
                    window.location.reload()
                }
                for (let item of items) {
                    let key = this.getItemKey(item)
                    let quantity = item.querySelector('[data-quantity-display]')
                    if (quantity) {
                        let number = quantity.innerHTML
                        for (let lineItem of cart.items) {
                            // console.log(lineItem.key + '  ' + key)
                            if (lineItem.key === key) {
                                number = lineItem.quantity
                                if (number <= 0) {
                                    this.removeItem(item)
                                }
                            }
                        }
                        quantity.innerHTML = number
                        item.dataset.quantity = number
                    }
                }
            }
        }
    }

    getItemKey (item) {
        let id = item.dataset.item
        if (id.indexOf(':') >= 0) {
            return id
        } else {
            return parseInt(id)
        }
    }
}

export default CartPage



// WEBPACK FOOTER //
// ./src/resources/scripts/components/CartPage.js